import sendEmail from './sendEmail';

export default [sendEmail];
